import { useEffect, useState } from 'react';

export const useId = (suffix?: string) => {
  const [id, setId] = useState('');
  useEffect(() => {
    if (id === '') {
      setId(`guest-${Math.round(Math.random() * 1e5)}${suffix ? `-${suffix}` : ''}`);
    }
  }, [id]);

  return id;
};
